import { mf, msg } from '../message-functions'

/**
  <span style="color:#85c1dc;">**EE:**</span>
  Osta külalisena

  <span style="color:#85c1dc;">**FI:**</span>
  Osta vieraana

  <span style="color:#85c1dc;">**RU:**</span>
  Купить как гость
*/
/* @__NO_SIDE_EFFECTS__ */
const m654 = msg(
  mf`Osta külalisena`,
  mf`Osta vieraana`,
  mf`Купить как гость`,
)

export { m654 as 'w.basket.continue_as_guest_mobile' }